import React, { useState } from "react";
import Select from "react-select";
import { UID_DROPDOWN } from "../../../DropdownConstants";

const ConfigPartOne = (props) => {
  const {
    serverConfig,
    handleClick,
    handleChange,
    styles,
    step,
    dropdownOptions,
    config,
    setConfig,
    setUid,
    uid,
    addSegment,
    deleteSegment,
    errors,
  } = props;

  const [formErrors, setFormErrors] = useState({
    name: "",
    source: "",
    uid: "",
    segments: [],
    config: "",
  });

  const validateForm = () => {
    let valid = true;
    const errors = {
      name: "",
      source: "",
      uid: "",
      segments: [],
      config: "",
    };

    if (!serverConfig.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    }

    if (!serverConfig.source.trim()) {
      errors.source = "Source is required";
      valid = false;
    }

    if (!uid) {
      errors.uid = "UID Type is required";
      valid = false;
    }

    if (serverConfig.segments.length === 0) {
      errors.segments.push("At least one segment is required");
      valid = false;
    } else {
      serverConfig.segments.forEach((segment, index) => {
        if (!segment.segment_name || !segment.field_number) {
          errors.segments[index] = "Both Type and Code are required";
          valid = false;
        } else {
          errors.segments[index] = "";
        }
      });
    }

    if (!config) {
      errors.config = "Router Config is required";
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    handleChange(e);

    switch (name) {
      case "name":
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          name: value.trim() !== "" ? "" : "Name is required",
        }));
        break;
      case "source":
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          source: value.trim() !== "" ? "" : "Source is required",
        }));
        break;
      default:
        break;
    }
  };

  const handleSubmit = () => {
    const isValid = validateForm();
    if (isValid) {
      handleClick("next");
    }
  };

  const formIsValid =
    serverConfig?.name?.trim() !== "" &&
    serverConfig?.source?.trim() !== "" &&
    uid &&
    serverConfig?.segments?.length > 0 &&
    serverConfig?.segments?.every(
      (segment) => segment?.segment_name && segment?.field_number
    ) &&
    config;

  return (
    <div>
      <div className="hl7-modal-inputs">
        <div>
          <div>
            <label className="label-fields font-weight-bold">
              Name: <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
            </label>
          </div>
          <div>
            <input
              className="text-input-modal"
              type="text"
              name="name"
              value={serverConfig?.name || ""}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
        <span className="errorStyles">{formErrors.name}</span>
        <div className="source">
          <div>
            <label className="label-fields font-weight-bold">
              Source: <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
            </label>
          </div>
          <div>
            <input
              className="text-input-modal"
              type="text"
              name="source"
              value={serverConfig?.source || ""}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
        <span className="errorStyles">{formErrors.source}</span>

        <div className="uuid-type">
          <div>
            <label className="label-fields font-weight-bold">
              UID Type:{" "}
              <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
            </label>
          </div>
          <Select
            placeholder="Select UID"
            name="config"
            options={UID_DROPDOWN}
            onChange={setUid}
            value={uid}
            isClearable={true}
            theme={(theme) => ({
              ...theme,
              borderRadius: "5px",
              colors: styles.colors,
            })}
            styles={{
              control: (provided) => ({
                ...provided,
                ...styles.controlStyles,
              }),

              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "black" : "white",
                color: state.isSelected ? "white" : "black",
              }),

              singleValue: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
              placeholder: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
            }}
          />
        </div>
        <span className="errorStyles">{formErrors.uid}</span>

        <div className="segmentss">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <label className="label-fields font-weight-bold">
                Segments{" "}
                <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
              </label>{" "}
            </div>
            <div className="mt-4">
              <i
                className="fa fa-plus"
                aria-hidden="true"
                onClick={addSegment}
                style={{ color: "white", cursor: "pointer" }}
              ></i>
            </div>
          </div>
          <div
            className={
              serverConfig.segments.length > 2 ? "segments-container" : ""
            }
          >
            {serverConfig.segments.map((segment, index) => (
              <div key={index} className="d-flex justify-content-between">
                <div className="segment-type segment ml-2 mr-2">
                  <label className="label-fields-check font-weight-bold">
                    Type
                  </label>
                  <input
                    className="text-input-modal-small"
                    type="text"
                    name={`segment_name-${index}`}
                    value={segment.segment_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="segment-code segment ml-2 mr-2">
                  <label className="label-fields-check font-weight-bold">
                    Code
                  </label>
                  <input
                    className="text-input-modal-small"
                    type="number"
                    name={`field_number-${index}`}
                    value={segment.field_number}
                    onChange={handleChange}
                  />
                </div>
                <div
                  className="delete-icon"
                  onClick={() => deleteSegment(index)}
                  style={{ cursor: "pointer", marginTop: "2rem" }}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            ))}
          </div>
          <span className="errorStyles">
            {formErrors.segments.length > 0 && formErrors.segments[0]}
          </span>
        </div>

        <div>
          <div>
            <label className="label-fields font-weight-bold">
              Router Config:{" "}
              <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
            </label>
          </div>
          <Select
            placeholder="Select Router Config"
            name="config"
            options={dropdownOptions}
            onChange={setConfig}
            value={config}
            isClearable={true}
            theme={(theme) => ({
              ...theme,
              borderRadius: "5px",
              colors: styles.colors,
            })}
            styles={{
              control: (provided) => ({
                ...provided,
                ...styles.controlStyles,
              }),

              option: (provided, state) => ({
                ...provided,
                backgroundColor: "black",
                color: "white",
              }),

              singleValue: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
              placeholder: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
            }}
          />
          <span className="errorStyles">{formErrors.config}</span>
        </div>

        <div className="d-flex justify-content-around">
          {step === 3 ? (
            <div className="d-flex justify-content-around">
              <div className="prev">
                <button
                  className="btn-class mt-3 "
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("prev")}
                >
                  PREV
                </button>
              </div>
              <div className="submit-config">
                <button
                  className="btn-class mt-3"
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  disabled={!formIsValid}
                  onClick={()=>handleSubmit("submit")}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between">
              {step !== 0 && (
                <div className="">
                <button
                  className="btn-class mt-3 "
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("prev")}
                >
                  PREV
                </button>
              </div>
              )}
              <div>
                <button
                  className="btn-class mt-3 ml-2 mr-2"
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  disabled={!formIsValid}
                  onClick={handleSubmit}
                >
                  NEXT
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigPartOne;
